import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "./pages/admin/Login.vue";
import Register from './pages/admin/Register.vue';
import Forgot from './components/login/Forgot.vue';
import Reset from './components/login/Reset.vue';
import Dashboard from "./components/dashboard/Dashboard.vue";
import AllCells from "./components/cells/AllCells.vue"
import AddCell from "./components/cells/AddCell.vue"
import Customers from "./components/customers/Customers.vue"
import Batteries from "./components/batteries/Batteries.vue"
import EditBattery from "./components/batteries/EditBattery.vue"
import Sales from "./pages/Sales/Sales.vue"
import WarrantiedSales from "./pages/Sales/WarrantiedSales.vue"
import PriceCalculator from "./pages/Sales/PriceCalculator.vue"
import CollectInfo from "./components/collectinfo/CollectInfo.vue"
import Cells from "./components/cells/Cells.vue"
import CustomerForm from "./components/customers/CustomerForm.vue"
import CustomerDetail from "./components/customers/CustomerDetail.vue"
import SaleForm from "./components/sales/SaleForm.vue"
import RecallFormV2 from "./components/sales/RecallFormV2.vue"
import BalancedCellTabs from "./components/balancedcells/BalancedCellTabs.vue";
import BroadcastLists from "./pages/BroadcastLists/BroadcastLists.vue";
import BroadcastListForm from "./pages/BroadcastLists/BroadcastListForm.vue";
import MessageTemplateForm from "./pages/BroadcastLists/MessageTemplateForm.vue";
import BookingForm from "./common/BookingForm.vue";
import BookingsList from "./pages/Bookings/BookingsList.vue";
import Inventory from "./pages/Inventory/Inventory.vue";
import DeleteCells from "./pages/Cells/Delete.vue";
import VueCookies from 'vue-cookies'


// import { broadcastLists } from './api';

Vue.use(VueRouter);


const routes = [
  {
    path: '/', name: 'Home', component: Dashboard, meta: {
      requiresAuth: true
    }
  },
  { path: '/register', component: Register },
  {
    path: '/login', name: 'Login', component: Login, meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login/forgotpassword', component: Forgot, meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login/resetpassword', component: Reset, meta: {
      requiresAuth: false
    }
  },
  { path: '/allcells', component: AllCells },
  { path: '/addcells', component: AddCell },
  { path: '/batteries', component: Batteries },
  { path: '/batteries/:batteryId', component: EditBattery },
  { path: '/customers', component: Customers },
  { path: '/customers/add', component: CustomerForm },
  { path: '/customers/view/:id', component: CustomerDetail },
  { path: '/customers/edit/:id', component: CustomerForm },
  { path: '/collectedinfo', component: CollectInfo },
  { path: '/cells', component: Cells },
  { path: '/sales', component: Sales },
  { path: '/warrantied-sales', component: WarrantiedSales },
  { path: '/price-calculator', component: PriceCalculator },
  { path: '/sales/add', component: SaleForm },
  { path: '/sales/edit/:id', component: SaleForm },
  { path: '/sales/:saleId/recall', component: RecallFormV2 },
  { path: '/sales/:saleId/recall/:id', component: RecallFormV2 },
  { path: '/balancedcells', component: BalancedCellTabs },
  { path: '/broadcast_lists', component: BroadcastLists },
  { path: '/broadcast_list/add', component: BroadcastListForm },
  { path: '/broadcast_list/:broadcastId', component: BroadcastListForm },
  { path: '/message_template/add', component: MessageTemplateForm },
  { path: '/message_template/:templateId', component: MessageTemplateForm },
  { path: '/booking', component: BookingForm },
  { path: '/bookings', component: BookingsList },
  { path: '/cells/delete', component: DeleteCells },
  { path: '/inventory', component: Inventory },
  { path: "*", redirect: '/' },
]

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const token = VueCookies.get("token");
  if (token && to.meta.requiresAuth == false) {
    return next({ path: '/' });
  }
  // else if (token == null && to.fullPath !== '/login') {
  //   //  router.push('/login')
  //   return next({ path: '/login' });
  // }
  next();
});

export default router;